/*  eslint-disable  */
import { CursorPointer, Flex, ThinSeparator } from 'styling/GlobalStyles'
import { UserOptionsContainer } from './NavBar.styled'
import { BodyText } from 'styling/Typography'
import useAuth from 'hooks/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { ToggleButton } from 'components/Input/ToggleButton'
import { changeTheme } from 'features/global/globalSlice'
import { LogoutIcon } from 'assets/icons/Log-outIcon'
import { useEffect, useRef } from 'react'

export const UserOptions = ({ setShow }) => {

    useEffect(() => {
        document.addEventListener('keydown', hideOnEscape, true)
        document.addEventListener('click', hideOnClickOutside, true)
    }, [])

    const hideOnEscape = (e) => {
        if (e.key === 'Escape') {
            setShow(false)
        }
    }
    const hideOnClickOutside = (e) => {
        if (ref.current && !ref.current.contains(e.target)) {
            setShow(false)
        }
    }


    const { user, logout } = useAuth()
    const { darkMode } = useSelector((store: RootState) => store.globals)
    const ref = useRef(null)
    const dispatch = useDispatch<AppDispatch>()
    return <UserOptionsContainer ref={ref}>
        <Flex column gap="0.5rem">
            <BodyText weight='bold' >{user.firstName + ' ' + user.lastName}</BodyText>
            <BodyText>{user?.currentContract?.role?.name || 'Admin'}</BodyText>
        </Flex>
        <ThinSeparator />
        <Flex center between >
            <BodyText weight='bold' style={{ width: '100%' }}>
                Dark Theme
            </BodyText>
            <ToggleButton state={darkMode} handleChange={() => dispatch(changeTheme())} />
        </Flex>
        <ThinSeparator />
        <CursorPointer>
            <Flex center gap='5px' onClick={() => logout()} >
                <LogoutIcon />
                <BodyText >Log out</BodyText>
            </Flex>
        </CursorPointer>
    </UserOptionsContainer>
}